import { createSlice, Tuple } from "@reduxjs/toolkit";

export const initialState = {
  Bot_Details: {},
  errormessage: null,
  loading: false,
  success: false,
  error: false,
  Bot_User:[],
  Tool_List:[],
  Database_Details_For_Bot:null

};

const Bot_Details = createSlice({
  name: "Bot_Details",
  initialState,
  reducers: {
    fetch_Bot_Details(state, action) {
      if(action.payload.question_answers){

        action.payload.question_answers = JSON.parse(action.payload.question_answers)
      }
      state.Bot_Details = action.payload;
      state.loading = false;
      state.success = true;
      state.errormessage = null;
      state.error = false;
      state.bot_update_success = false;
      state.bot_update_fail = false;
   
    },
    fetch_Bot_Details_Failed(state, action) {
    
      state.Bot_Details = {};
      state.loading = false;
      state.errormessage = action.payload;
      state.error = true;
    },
    reset_Bot_Details_Change(state) {
        state.Bot_Details = {};
        // state.loading = false;
        state.success = true;
        state.errormessage = null;
        state.error = false;
    },
     
    start_Bot_Details_loader(state) {
      state.loading = true;
    },
    update_bot_details_success(state,action){
        state.bot_update_success = true;
        state.bot_update_fail = false;
        state.errormessage = action.payload;
        state.loading = false;
    },
    update_bot_details_fail(state,action){
        state.bot_update_success = false;
        state.bot_update_fail = true;
        state.errormessage = action.payload;
        state.loading = false;
    },
    fetch_Bot_User_success(state,action){
       state.Bot_User = action.payload;
       state.loading = false;
    }
    ,
    fetch_Bot_User_fail(state,action){
       state.Bot_User = [];
       state.loading = false;
    },
    update_old_file_list(state,action){
      state.Bot_Details.Files_Path = action.payload
    },
    add_user_to_bot_sucess(state, action){
         state.loading = false

    },
    add_user_to_bot_fail(state, action){
      state.loading = false
      state.error = true
      state.errormessage = action.payload
      
 },
 set_tool_list: (state, action) => {
  
  state.Tool_List = action.payload;
  // state.loading = false;
},

set_database_details_for_bot(state,action){
 state.Database_Details_For_Bot = action.payload
},
 reset_Bot_Details: () => initialState, // 🔥 Reset everything to the initial state
  

  },
 
});

export const {
  set_tool_list,
    fetch_Bot_Details,
    fetch_Bot_Details_Failed,
    reset_Bot_Details_Change,
    start_Bot_Details_loader,
    update_bot_details_success,
    update_bot_details_fail,
    fetch_Bot_User_fail,
    fetch_Bot_User_success,
    update_old_file_list,
    add_user_to_bot_sucess,
    add_user_to_bot_fail,
    reset_Bot_Details,
    set_database_details_for_bot
} = Bot_Details.actions;

export default Bot_Details.reducer;